import { render, staticRenderFns } from "./ListProductMenu.vue?vue&type=template&id=0621e25e&"
import script from "./ListProductMenu.vue?vue&type=script&lang=js&"
export * from "./ListProductMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListProductMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports